function toggleContent(e) {
    const $this = $(this);
    let $content = $this.prev('.showMoreToggleContent');
    let more = $content.hasClass('more');
    $this.toggleClass('more');
    $content.toggleClass('more');

    let buttonText = more
        ? $this.data('labelMore')
        : $this.data('labelLess');

    $this.text(buttonText);
}

export function watchToggleStateChanges() {
    $('.showMoreToggle').on('click', toggleContent);
}

export function initToggle() {
    let offset = 20;
    $('.showMoreToggleContent').each(function(i) {
        const $this = $(this);
        if($this[0].scrollHeight > $this.innerHeight() + offset) {
            $this.next('.showMoreToggle').show();
        }
    });
}
